import { AuthProvider } from './AuthProvider';
import App from './App';

function AppWrapper() {
  return (
    <AuthProvider>
      <App />
    </AuthProvider>
  );
}

export default AppWrapper;
